var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_icon",
    transform: "translate(-375 -1362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M26,0H0V26H26Z",
    transform: "translate(375 1362)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M14.666,9.239V6.062a3.812,3.812,0,1,0-7.625,0V9.239M6.406,18.77h8.9a1.906,1.906,0,0,0,1.906-1.906V11.146A1.906,1.906,0,0,0,15.3,9.239h-8.9A1.906,1.906,0,0,0,4.5,11.146v5.719A1.906,1.906,0,0,0,6.406,18.77Z",
    transform: "translate(377.146 1364.49)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.50d4ddd0957aff3259c3e291f2526d4e.svg";
export { ForwardRef as ReactComponent };